module.exports = __webpack_public_path__ + "img/code.2ee2b7f4.png";